import { RevelioPageId } from '../types';

const OVERVIEW_PAGE_IDS: ReadonlySet<string> = new Set([
  RevelioPageId.COMPANY_OVERVIEW_V2,
  RevelioPageId.GEOGRAPHY_OVERVIEW,
  RevelioPageId.ROLE_OVERVIEW,
]);

export const isOverviewPage = (
  revelioPageId: string | undefined | null
): boolean => {
  if (!revelioPageId) return false;
  return OVERVIEW_PAGE_IDS.has(revelioPageId);
};
